import { Collapse, useTheme } from '@material-ui/core'
import React, { useState, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import {
  ArrowDropDownRounded as ArrowDropDown,
  ArrowDropUpRounded as ArrowDropUp,
} from '@material-ui/icons'

import Typography from '../display/typography'

import useStyles from './ballonTabsStyle'

const BalloonAgent = ({ data, ...props }) => {
  const { t } = useTranslation()

  const size = useSelector((state) => state.preferences)
  const theme = useTheme()
  let useStylesParams = {
    size: size,
    resize: props?.resize,
  }
  const classes = useStyles(useStylesParams)

  const [isOpen, setIsOpen] = useState(true)

  function toggle() {
    setIsOpen((prev) => !prev)
  }

  const renderHeader = () => {
    return (
      <>
        <div className={classes.header} onClick={toggle}>
          <Typography variant="body1" component="h4">
            {t('commons.Tabs')}
          </Typography>
          <span
            style={{
              marginRight: 6,
              color:
                theme.palette.type === 'dark'
                  ? '#fff'
                  : theme.palette.primary.secondary,
            }}
          >
            {t(isOpen ? 'commons.ViewLess' : 'commons.ViewMore')}
            {isOpen ? <ArrowDropUp /> : <ArrowDropDown />}
          </span>
        </div>
      </>
    )
  }
  return (
    <>
      <div className={classes.root} style={props.style}>
        <div className={classes.child}>
          {renderHeader()}
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            {data?.tabs?.[0] && (
              <div className={classes.item}>
                <p>{t('commons.Level') + ' 1'}</p>
                <Typography
                  component="div"
                  style={{
                    overflowWrap: 'anywhere',
                    whiteSpace: 'pre-wrap',
                    fontWeight: 'bold',
                  }}
                  variant="body1"
                >
                  <span
                    className={'escapeDragScroll'}
                    style={{ cursor: 'text' }}
                  >
                    {data?.tabs?.[0]?.tabName}
                  </span>
                </Typography>
              </div>
            )}
            {data?.tabs?.[1] && (
              <div className={classes.item}>
                <p>{t('commons.Level') + ' 2'}</p>
                <Typography
                  component="div"
                  style={{
                    overflowWrap: 'anywhere',
                    whiteSpace: 'pre-wrap',
                    fontWeight: 'bold',
                  }}
                  variant="body1"
                >
                  <span
                    className={'escapeDragScroll'}
                    style={{ cursor: 'text' }}
                  >
                    {data?.tabs?.[1]?.tabName}
                  </span>
                </Typography>
              </div>
            )}
            {data?.tabs?.[2] && (
              <div className={classes.item}>
                <p>{t('commons.Level') + ' 3'}</p>
                <Typography
                  component="div"
                  style={{
                    overflowWrap: 'anywhere',
                    whiteSpace: 'pre-wrap',
                    fontWeight: 'bold',
                  }}
                  variant="body1"
                >
                  <span
                    className={'escapeDragScroll'}
                    style={{ cursor: 'text' }}
                  >
                    {data?.tabs?.[2]?.tabName}
                  </span>
                </Typography>
              </div>
            )}
          </Collapse>
        </div>
      </div>
    </>
  )
}

export default memo(BalloonAgent)